import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import axios from "axios";
import SrvButton from "../../../components/global/SrvButton";
import ErrorAdd from "../../../util/ErrorAdd";

function ModalAdd({ show, onHide }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    function activate() {
        axios.post('/api_tracker/billing/companyActivation', { ID_Status: 1 })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    onHide();
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Активация компании</div>

                    <div className="text-center">
                        После активации необходимо добавить всех пользователей и произвести оплату услуг.
                        <br></br>
                        После активации пробный период будет недоступен.
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="play" loading={loading} size={'lg'} onClick={() => activate()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
}
export default ModalAdd;
